import Service from '../service/service-container';
import getContantPage from './content';
import { contentType, propsType } from './types';

const Welcome = ({service, children} : propsType): JSX.Element => {
	const contentPage: contentType = getContantPage(service);
  
	return (
		<section className="welcome">
			<div className="welcome__container container">
				<h1>{contentPage.title}</h1>
				<h2>{contentPage.subtitle}</h2>
				{children}
			</div>
		</section>
	);
};

export default Welcome;
